import React, { useState } from "react";
import {
  Grid,
  Box,
  ListItemIcon,
  ListItemText,
  Collapse,
  Chip,
} from "@mui/material";
import BadgeIcon from "@mui/icons-material/Badge";
import { ListItem, ListItemButton } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import SchoolInformation from "./educational_info_tab/school_information";
import { pcolor } from "../../style2";

export default function EducationalInfo(props) {

  const [openSchoolInformation, setOpenSchoolInformation] = useState(false);

  const isSchoolInformationEmpty = () => {
    let profile = props.profile;
    if (profile.childEducation == null)
      return true;
    if (profile.childEducation?.schoolName !== "")
      return false;
    if (profile.childEducation?.class !== "")
      return false;

    if (profile.childEducation?.schoolNurseName !== "")
      return false;
    if (profile.childEducation?.teacherName !== "")
      return false;

    if (profile.childEducation?.teachingAssistantName && profile.childEducation?.teachingAssistantName !== "")
      return false;

    if (profile.childEducation?.specificProblems && profile.childEducation?.specificProblems !== "")
      return false;
    if (profile.childEducation?.specialEducationPlan !== null)
      return false;
    return true;
  }
  return (
      <Grid container>
        <Grid item sm={12}>
          <Box m={2}>
            <ListItem>
              <ListItemButton disabled={isSchoolInformationEmpty()}
                onClick={() => setOpenSchoolInformation(!openSchoolInformation)}
                sx={{ color: pcolor, borderBottom: "0.1px solid grey" }}>
                <ListItemIcon>
                  <BadgeIcon sx={{ color: pcolor }} />
                </ListItemIcon>
                <ListItemText primary={<>School Information {isSchoolInformationEmpty() ? <Chip label="No data provided" size="small" /> : null}</>} />
                {openSchoolInformation ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
            </ListItem>
          </Box>
          <Collapse in={openSchoolInformation} timeout='auto' unmountOnExit>
            <Box style={{ padding: "0px 15px" }}>
              <SchoolInformation profile={props.profile} />
            </Box>
          </Collapse>
        </Grid>
      </Grid>
  );
}
